// extracted by mini-css-extract-plugin
export var header = "_bz-0";